import React from "react";
import {SiDeliveroo} from "react-icons/si";

export default function ButtonDeliverooComponent() {
    return (
        <a
            className="bg-[#00CBCC] flex items-center justify-center w-[60px] h-[40px] rounded-lg"
            href="https://www.ubereats.com/fr/store/o-jardin-secret/WI1LazKMTamLSS9yGvZ1_Q"
            target="_blank"
            rel="noreferrer"
        >
            <SiDeliveroo/>
        </a>
    );
}
